var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Doc',_vm._g({ref:"doc",attrs:{"type":"hywj","module-name":"DocHywj"}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }